import { configureStore } from "@reduxjs/toolkit";
import { dataSlice } from "../slices/data-slice";
// ...

export const store = configureStore({
  reducer: {
    data: dataSlice.reducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
